export const Props = (props = {}) => {
    const minWidth = Number(props.minWidth || 0);
    const maxWidth = isFinite(Number(props.maxWidth)) && !isNaN(Number(props.maxWidth)) && props.maxWidth != null
        ? Number(props.maxWidth)
        : Infinity;
    const conditions = [`(min-width: ${minWidth}px)`, isFinite(maxWidth) ? `(max-width: ${maxWidth}.98px)` : null]
        .filter(Boolean)
        .join(' and ');
    return {
        minWidth: minWidth,
        // default to and allow infinity
        maxWidth: maxWidth,
        query: String(props.query || conditions || '')
    };
};
export const validate = () => true;
export const fix = (props, styles) => props;
export const type = 'breakpoint';
export const label = 'Breakpoints';
export const category = 'basic';
export const forms = [
    {
        id: 'breakpoint',
        label: 'Breakpoint',
        extractProperties: (props) => props,
        validate: () => true
    }
];
//# sourceMappingURL=breakpoint.js.map